/* Bruised: the feedback form page (/pages/form). Loaded by sections/bruised-feedback.liquid only.

   What it does, and nothing else: takes the four answers and the email, posts them to the
   bruised-forms Worker, and swaps the form for the code the Worker hands back. No page reload and no
   redirect: the code appears where the form was.

   Three rules it never breaks.
     1. What somebody typed is never thrown away. A refusal, a rate limit, a dead network: the boxes
        keep every character, and a draft is written to this browser's own storage as they type, so
        even a reload or a closed tab does not cost them the answers.
     2. Nothing is invented. The Worker decides whether there is a code. "saved" means saved, and the
        page says exactly that instead of showing a code that does not exist.
     3. No answer and no address is ever put on the page. The only thing that comes back from the
        Worker and lands in the DOM is that person's own code.

   Keyboard and screen reader: real labels, real buttons, aria-describedby on the box that needs
   more, focus moved to it, and the result panel takes focus when it replaces the form. */
(function () {
  'use strict';
  if (window.__bruisedFeedback) return;
  window.__bruisedFeedback = 1;

  var KEYS = ['a1', 'a2', 'a3', 'a4'];
  var STORE = 'bruised:feedback:v1';

  /* browser storage is a convenience, never a requirement: a private window, blocked site data or a
     thumbnail capture can make any of this throw, and the page has to work exactly the same */
  function readStore() {
    try { return JSON.parse(localStorage.getItem(STORE) || '{}') || {}; } catch (e) { return {}; }
  }
  function writeStore(patch) {
    try {
      var next = readStore();
      for (var k in patch) if (Object.prototype.hasOwnProperty.call(patch, k)) next[k] = patch[k];
      localStorage.setItem(STORE, JSON.stringify(next));
    } catch (e) {}
  }
  function deviceId() {
    var s = readStore();
    if (!s.device) {
      var d = 'd';
      try {
        var b = new Uint8Array(8);
        (window.crypto || {}).getRandomValues ? window.crypto.getRandomValues(b) : b.forEach(function (_, i) { b[i] = Math.floor(Math.random() * 256); });
        for (var i = 0; i < b.length; i++) d += b[i].toString(16);
      } catch (e) { d += String(Date.now()) + String(Math.random()).slice(2); }
      writeStore({ device: d });
      return d;
    }
    return s.device;
  }

  function mount(root) {
    if (root.__bfbReady) return;
    root.__bfbReady = 1;

    var form = root.querySelector('[data-bfb-form]');
    var done = root.querySelector('[data-bfb-done]');
    var saved = root.querySelector('[data-bfb-saved]');
    var codeEl = root.querySelector('[data-bfb-code]');
    var copyBtn = root.querySelector('[data-bfb-copy]');
    var status = root.querySelector('[data-bfb-status]');
    var submit = root.querySelector('[data-bfb-submit]');
    if (!form || !done || !saved || !codeEl) return;

    var api = (root.getAttribute('data-bfb-api') || '').replace(/\/+$/, '');
    var source = root.getAttribute('data-bfb-source') || 'page-form';
    var offlineText = root.getAttribute('data-bfb-offline') || 'That did not send. Your answers are still here, press it again.';
    var copyText = copyBtn ? copyBtn.textContent : '';
    var copiedText = root.getAttribute('data-bfb-copied') || 'Copied';
    var fields = {};
    KEYS.concat(['email', 'consent']).forEach(function (k) { fields[k] = form.querySelector('[data-bfb-field="' + k + '"]'); });

    /* ---- errors: shown under the box, read out, and the box keeps what is in it ---- */
    function clearErrors() {
      if (status) status.textContent = '';
      Object.keys(fields).forEach(function (k) {
        var el = fields[k];
        if (!el) return;
        el.removeAttribute('aria-invalid');
        var slot = form.querySelector('[data-bfb-error="' + k + '"]');
        if (slot) { slot.textContent = ''; slot.classList.remove('is-on'); }
      });
    }
    function showError(field, message) {
      var el = field && fields[field];
      var slot = field && form.querySelector('[data-bfb-error="' + field + '"]');
      if (el && slot) {
        el.setAttribute('aria-invalid', 'true');
        slot.textContent = message;
        slot.classList.add('is-on');
        /* scroll the whole question into view, not the box: the person needs to see what they were
           asked before they see that it was refused. The browser's own focus scroll puts the box
           under the theme's sticky header, so it is done here and focus is told not to scroll. */
        var block = (el.closest && (el.closest('.bruised-feedback__q') || el.closest('.bruised-feedback__tail'))) || el;
        if (block.scrollIntoView) { try { block.scrollIntoView({ block: 'start', behavior: 'smooth' }); } catch (e) { block.scrollIntoView(true); } }
        try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
        return;
      }
      if (status) status.textContent = message;              // no box to blame: say it once, above the button
      if (!el && submit) { try { submit.focus(); } catch (e) {} }
    }

    /* ---- the draft: this browser's own storage, so a reload costs nothing ---- */
    var draft = readStore();
    KEYS.concat(['email']).forEach(function (k) {
      if (fields[k] && draft[k] && !fields[k].value) fields[k].value = draft[k];
    });
    if (fields.consent && draft.consent) fields.consent.checked = true;
    function saveDraft() {
      var patch = {};
      KEYS.concat(['email']).forEach(function (k) { if (fields[k]) patch[k] = fields[k].value; });
      if (fields.consent) patch.consent = !!fields.consent.checked;
      writeStore(patch);
    }
    form.addEventListener('input', saveDraft);
    form.addEventListener('change', saveDraft);

    /* the count only appears when somebody is near the ceiling, so it is never clutter */
    KEYS.forEach(function (k) {
      var el = fields[k];
      var out = form.querySelector('[data-bfb-count="' + k + '"]');
      if (!el || !out) return;
      var max = parseInt(el.getAttribute('maxlength'), 10) || 2000;
      var tick = function () {
        var left = max - el.value.length;
        out.hidden = left > 200;
        out.textContent = left + ' characters left';
      };
      el.addEventListener('input', tick);
      tick();
    });

    /* ---- what replaces the form ---- */
    function reveal(panel) {
      form.hidden = true;
      panel.hidden = false;
      try { panel.focus({ preventScroll: true }); } catch (e) { try { panel.focus(); } catch (e2) {} }
      if (panel.scrollIntoView) { try { panel.scrollIntoView({ block: 'start', behavior: 'smooth' }); } catch (e) { panel.scrollIntoView(true); } }
    }
    function showCode(code) {
      codeEl.textContent = code;
      codeEl.classList.toggle('is-long', String(code).length > 14);
      reveal(done);
      writeStore({ code: code, a1: '', a2: '', a3: '', a4: '' });
    }

    /* somebody who already has their code sees it again when they come back to this page on this
       browser. The Worker is still the source of truth: the same email always gets the same code. */
    if (draft.code) showCode(draft.code);

    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var text = codeEl.textContent || '';
        var say = function (okText) {
          copyBtn.textContent = okText;
          if (copyBtn.__t) clearTimeout(copyBtn.__t);
          copyBtn.__t = setTimeout(function () { copyBtn.textContent = copyText; }, 2400);
        };
        var fallback = function () {
          try {
            var r = document.createRange();
            r.selectNodeContents(codeEl);
            var sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(r);
            document.execCommand('copy');
            say(copiedText);
          } catch (e) { say(copyText); }
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text).then(function () { say(copiedText); }, fallback);
        } else fallback();
      });
    }

    /* ---- submit ---- */
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      clearErrors();

      /* the same three rules the Worker applies, checked here first so the answer never leaves the
         browser to be refused. The Worker checks them again: this is manners, not security. */
      for (var i = 0; i < KEYS.length; i++) {
        var el = fields[KEYS[i]];
        if (!el) continue;
        var text = el.value.replace(/\s+/g, ' ').trim();
        if (!text) return showError(KEYS[i], el.getAttribute('data-bfb-empty') || 'This one is blank. Tell us what you think.');
        var words = text.split(' ').filter(function (w) { return /[0-9a-z]/i.test(w) || /[^\x00-\x7F]/.test(w); });
        if (words.length < 2 && text.length < 12) return showError(KEYS[i], el.getAttribute('data-bfb-short') || 'One word is not an answer. A sentence is plenty.');
      }
      if (fields.email && !fields.email.value.trim()) return showError('email', 'Enter your email. It is how the code finds you.');
      if (fields.consent && !fields.consent.checked) return showError('consent', fields.consent.getAttribute('data-bfb-needed') || 'Tick the box so we know we can keep this.');

      if (!api) { if (status) status.textContent = offlineText; return; }

      var body = { email: fields.email ? fields.email.value.trim() : '', consent: true, source: source, device: deviceId(), company: (form.querySelector('[data-bfb-hp]') || {}).value || '' };
      body.consent_text = (root.querySelector('[data-bfb-consent-text]') || {}).textContent || '';
      body.consent_text = body.consent_text.replace(/\s+/g, ' ').trim();
      body.questions = {};
      KEYS.forEach(function (k) {
        body[k] = fields[k] ? fields[k].value : '';
        var lab = form.querySelector('[data-bfb-question="' + k + '"]');
        body.questions[k] = lab ? lab.textContent.replace(/\s+/g, ' ').trim() : '';
      });

      if (submit) { submit.setAttribute('aria-busy', 'true'); submit.disabled = true; }
      fetch(api + '/submit', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (j) { return { status: r.status, body: j || {} }; }); })
        .then(function (res) {
          if (res.status === 200 && res.body.ok && res.body.state === 'code' && res.body.code) return showCode(res.body.code);
          if (res.status === 200 && res.body.ok) { reveal(saved); return; }   // stored, no pool yet. Said plainly.
          showError(res.body.field, res.body.error || offlineText);
        })
        .catch(function () { if (status) status.textContent = offlineText; })
        .then(function () { if (submit) { submit.removeAttribute('aria-busy'); submit.disabled = false; } });
    });
  }

  function boot() {
    var list = document.querySelectorAll('[data-bfb-root]');
    for (var i = 0; i < list.length; i++) mount(list[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  /* the theme editor rebuilds a section's markup in place, which throws the old listeners away */
  document.addEventListener('shopify:section:load', boot);
})();
